<template>
    <div class="w-100" style="min-width: 300px">
        <v-select v-if="customers" class="vue-select2" id="cust_id" name="select2"
                  :options="customers" label="na"
                  :model.sync="selected_customer"
                  v-model="selected_customer"
                  :searchable="true" language="lt-LT">
        </v-select>
        <input type="text" v-if="!customers" class="form-control" value="Rasti klientą (fix: be LT raidžių)" @focus="loadCustomers()">
    </div>
</template>

<script>
    import vSelect from 'vue-select';
    export default {
        name: "CustomerSearch",
        components: {
            vSelect,
        },
        data() {
            return {
                customers: '',
                selected_customer: ''
            }
        },
        methods: {
          loadCustomers() {
              axios.get('/get_customers').then(res => {
                  var mapObj = {
                      ą:"a",
                      č:"c",
                      ę:'e',
                      ė:'e',
                      į:"i",
                      ų:"u",
                      ū:"u",
                      š:"s",
                      ž:"z",
                      Ą:"A",
                      Č:"C",
                      Ę:"E",
                      Ė:"E",
                      Į:"I",
                      Š:"S",
                      Ų:"U",
                      Ū:"U",
                      Ž:"Z"

                  };
                  for (let index = 0; index < res.data.length; index++) {
                      var str = res.data[index].name + ' ' + res.data[index].address + ' ' + res.data[index].phone;
                      var fix = str.replace(/ą|č|ę|ė|į|š|ų|ū|ž/gi, function(matched){
                          return mapObj[matched];
                      });
                      res.data[index].na = fix;
                      
                  }
                  // console.log(res.data);
                  this.customers = res.data;
                  $("#cust_id").find("input").focus();
              });
            }
        },
        mounted() {
            // this.$refs.searchbar.$el.focus();
            // axios.get('/get_customers').then(res => {
            //     this.customers = res.data
            // });
        },
        watch: {

            selected_customer: function (val) {
                window.location.assign('/customer/' + val.id);
            }
        }
    }
</script>

<style scoped>

</style>